export default "__VITE_PUBLIC_ASSET__5670c3b6__"